import { shortId } from '../../../lib/ids';
import { Navigate, useParams } from 'react-router';

/**
 * `/moje-podnety/:reportId` → `/podnety/MQRJ73F`.
 *
 * Podnet samostatnú stránku nemá - jeho detail žije **nad mapou**, v paneli
 * na hlavnej stránke ([[FeedDetail]]), a jeho adresa je `/podnety/<ID>`,
 * ktorú obsluhuje priamo [[HomePage]]. Staré `/moje-podnety/:reportId` sem
 * ostáva kvôli rozposlaným odkazom; **nemazať**. Do adresy ide krátke ID; z URN
 * (`urn:…:pdnt:MQRJ73F`) aj z appkovej podoby (`pdnt:MQRJ73F`) ho vytiahne
 * `shortId`, takže presmerovanie znesie všetky tri tvary z [[ids]].
 *
 * Na mobile má tá istá vec ešte druhú cestu: zo „Mojich podnetov" sa detail
 * vysunie ako modálny sheet nad zoznamom, bez odchodu na mapu - viď
 * [[MyReports]].
 */
const ReportDetailRedirect: React.FC = () => {
  const { reportId } = useParams() as { reportId?: string };

  return (
    <Navigate
      replace
      to={`/podnety/${encodeURIComponent(shortId(reportId))}`}
    />
  );
};

export default ReportDetailRedirect;
